import './style.css';

import { currentUser, set } from './state';
import { doLogin, isAdmin, logout, showApp, toggleFieldPw, togglePw } from './modules/auth';
import { closeCdd, closeModal, getRichData, initDropdownDismiss, richAddLink, richFormat, richToggleImg, toast, toggleCdd } from './modules/ui';
import { setDateRange as setDateRangeSummary, exportSummaryCSV } from './modules/summary';
import {
  addNote, advance, assignSelf, changePriority, closeMobileDetail,
  loadTickets, openNotify, selectTicket, sendNotify, setFilter,
  setPriFilter, closeTicketUI, switchPage,
} from './modules/tickets';
import {
  initAdminPage, switchAdminSection, showUserForm, editUser,
  deleteUser, submitUserForm,
} from './modules/admin/users';
import {
  addAdminStepRow, cancelAdminTopicForm, deleteAdminTopic, editAdminTopic,
  moveAdminTopic, removeAdminStepRow, showAdminTopicForm,
  submitAdminTopicForm, syncTopicColorFromHex,
} from './modules/admin/topics';
import { saveWorkerUrl, testConnection } from './modules/admin/connection';
import { saveSheetUrl, openSheet } from './modules/admin/sheets';
import { saveLineConfig, syncLineColor } from './modules/admin/line';

// ── App init ──
window.addEventListener('load', () => {
  const saved = sessionStorage.getItem('hr_session');
  if (saved) {
    try {
      set.currentUser(JSON.parse(saved));
      showApp();
    } catch { sessionStorage.removeItem('hr_session'); }
  }
  initDropdownDismiss();
});

// ── Expose to window for inline event handlers ──
// (Phase 2: replace with addEventListener bindings)
declare global {
  interface Window {
    doLogin: typeof doLogin;
    togglePw: typeof togglePw;
    toggleFieldPw: typeof toggleFieldPw;
    logout: typeof logout;
    loadTickets: typeof loadTickets;
    switchPage: typeof switchPage;
    selectTicket: typeof selectTicket;
    closeMobileDetail: typeof closeMobileDetail;
    setFilter: typeof setFilter;
    setPriFilter: typeof setPriFilter;
    toggleCdd: typeof toggleCdd;
    closeCdd: typeof closeCdd;
    advance: typeof advance;
    changePriority: typeof changePriority;
    assignSelf: typeof assignSelf;
    closeTicketUI: typeof closeTicketUI;
    addNote: typeof addNote;
    openNotify: typeof openNotify;
    sendNotify: typeof sendNotify;
    closeModal: typeof closeModal;
    setDateRange: typeof setDateRangeSummary;
    exportSummaryCSV: typeof exportSummaryCSV;
    initAdminPage: typeof initAdminPage;
    switchAdminSection: typeof switchAdminSection;
    showUserForm: typeof showUserForm;
    editUser: typeof editUser;
    deleteUser: typeof deleteUser;
    submitUserForm: typeof submitUserForm;
    showAdminTopicForm: typeof showAdminTopicForm;
    editAdminTopic: typeof editAdminTopic;
    deleteAdminTopic: typeof deleteAdminTopic;
    moveAdminTopic: typeof moveAdminTopic;
    addAdminStepRow: typeof addAdminStepRow;
    removeAdminStepRow: typeof removeAdminStepRow;
    cancelAdminTopicForm: typeof cancelAdminTopicForm;
    submitAdminTopicForm: typeof submitAdminTopicForm;
    syncTopicColorFromHex: typeof syncTopicColorFromHex;
    saveLineConfig: typeof saveLineConfig;
    syncLineColor: typeof syncLineColor;
    saveWorkerUrl: typeof saveWorkerUrl;
    testConnection: typeof testConnection;
    saveSheetUrl: typeof saveSheetUrl;
    openSheet: typeof openSheet;
    richFormat: typeof richFormat;
    richToggleImg: typeof richToggleImg;
    richAddLink: typeof richAddLink;
  }
}

Object.assign(window, {
  doLogin, togglePw, toggleFieldPw, logout, loadTickets, switchPage,
  selectTicket, closeMobileDetail, setFilter, setPriFilter, toggleCdd, closeCdd,
  advance, changePriority, assignSelf, closeTicketUI, addNote, openNotify,
  sendNotify, closeModal, setDateRange: setDateRangeSummary, exportSummaryCSV,
  initAdminPage, switchAdminSection, showUserForm, editUser, deleteUser,
  submitUserForm, showAdminTopicForm, editAdminTopic, deleteAdminTopic,
  moveAdminTopic, addAdminStepRow, removeAdminStepRow, cancelAdminTopicForm,
  submitAdminTopicForm, syncTopicColorFromHex, saveLineConfig, syncLineColor,
  saveWorkerUrl, testConnection, saveSheetUrl, openSheet,
  richFormat, richToggleImg, richAddLink,
});

// ── Re-export for potential future direct imports ──
export { doLogin, logout, isAdmin, currentUser, toast };
